import * as React from 'react';
import './viewAsMode.scss';
import { useActions } from '../viewActions';
import { useSelector } from '../../../utils/useSelector';
import { WarningDiamond } from 'rcd-cpp-ui/ui/icon/WarningDiamond';
import { Secondary } from 'rcd-cpp-ui/ui/button';
import { UserGroup } from '../../Icon/icon';

export const ViewAsMode = () => {
  const viewingAs = useSelector(s => s.view?.viewingAs);
  const actingAs = useSelector(s => s.view?.actingAs);
  const viewName = useSelector(s => s.view?.selected?.props?.name);
  const { setActingAs, setViewingAs } = useActions();
  if (!viewingAs?.props) return null;

  const onClick = () => {
    if (actingAs) setActingAs(undefined);
    else setViewingAs(undefined);
  };
  const type = actingAs ? 'Act' : 'View';

  return (
    <div className="view-as-mode">
      <div>
        <span>
          <WarningDiamond />
        </span>
        <span>{type} As Mode</span>
        <span>|</span>
        <span>
          {type}ing {viewName} for {viewingAs.props.name}
        </span>
      </div>
      <div>
        <Secondary onClick={onClick}>
          <UserGroup /> Exit {type} As Mode
        </Secondary>
      </div>
    </div>
  );
};
